"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "frontone": {
    "4bdbaa24": [{
      "hkey": "ba3c433b",
      "slug": "buonconsiglio-colombara",
      "name": "Buonconsiglio-Colombara",
      "primary": true,
      "skipSearch": false
    }],
    "buonconsiglio": [{
      "hkey": "ba3c433b",
      "slug": "buonconsiglio-colombara",
      "name": "Buonconsiglio-Colombara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bb935180": [{
      "hkey": "0ff14ac0",
      "slug": "caprile",
      "name": "Caprile",
      "primary": true,
      "skipSearch": false
    }],
    "caprile-foce": [{
      "hkey": "0ff14ac0",
      "slug": "caprile",
      "name": "Caprile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6eb1b629": [{
      "hkey": "33fa7de9",
      "slug": "frontone",
      "name": "Frontone",
      "primary": true,
      "skipSearch": false
    }],
    "san-savino": [{
      "hkey": "33fa7de9",
      "slug": "frontone",
      "name": "Frontone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;